import React from 'react'
import {
  FormGroup, FormControl, ControlLabel, Modal
} from 'react-bootstrap'

import Button from '../components/Button'

import { getText } from '../lib/text'

export default class ModalNameEditor extends React.Component {
  constructor(props) {
    super(props)
    this.state = { title: props.value && props.value.title, chTitle: props.value && props.value.chTitle }
  }

  render() {
    const { onClose, onChange, headerTitle} = this.props
    document.addEventListener('keypress', e => {
      const key = e.which || e.keyCode;
      if (key === 13) { // 13 is enter
        onChange(this.state.title, this.state.chTitle)
      }
    })

    return (
      <Modal show onHide={() => this.props.onClose()}>
        <Modal.Header>
          {getText(headerTitle)}
        </Modal.Header>
        <Modal.Body>

          <FormGroup>
            <ControlLabel>
              {getText("🇨🇳 Nombre para cliente")}
            </ControlLabel>
            <FormControl
              className= "name-control"
              type="text"
              value={this.state.chTitle}
              onChange={evt => this.setState({ chTitle: evt.target.value })}
            />
          </FormGroup>

          <FormGroup>
            <ControlLabel>
              {getText("🇪🇸 Nombre interno")}
            </ControlLabel>
            <FormControl
              onChange={evt => this.setState({ title: evt.target.value })}
              value={this.state.title}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onClose()}>
            {getText("Cancelar")}
          </Button>
          <Button
            disabled={!this.state.chTitle}
            bsStyle="success"
            onClick={() => onChange(this.state.title, this.state.chTitle)}
          >
            {getText("Guardar")}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
